import { render, staticRenderFns } from "./user_name.vue?vue&type=template&id=58f84998&scoped=true&"
import script from "./user_name.vue?vue&type=script&lang=js&"
export * from "./user_name.vue?vue&type=script&lang=js&"
import style0 from "./user_name.vue?vue&type=style&index=0&id=58f84998&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f84998",
  null
  
)

export default component.exports